import { render, staticRenderFns } from "./MyMaterialCard.vue?vue&type=template&id=59da1779"
import script from "./MyMaterialCard.vue?vue&type=script&lang=js"
export * from "./MyMaterialCard.vue?vue&type=script&lang=js"
import style0 from "./MyMaterialCard.vue?vue&type=style&index=0&id=59da1779&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports